<template>
  <div class="user-menu">
    <a
      v-if="!isLoggedRef || appState$$.inProgress"
      aria-label="Buscar"
      class="user-menu__search"
      href="https://www.transportes.gob.es/buscador"
      target="_blank"
      tabindex="0"
    >
      Buscar
      <i class="user-menu__search__icon pi pi-search"></i>
    </a>
    <div
      v-else
      class="user-menu__logged"
    >
      <span class="user-menu__logged__name">
        {{ userDataRef?.fullName }}
      </span>
      <Button
        icon="pi pi-sign-out"
        severity="danger"
        aria-label="Desconectar"
        class="user-menu__logged__icon"
        tabindex="0"
        @click="logout"
        @keyup.enter="logout"
      />
    </div>
  </div>
</template>

<script setup>
import {
  inject,
  onMounted,
  shallowRef,
  watch,
} from 'vue';

// #region STTEDRA
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

import {useRouter} from 'vue-router';
import useComposeUser from '@/composables/compose-user';
import Button from 'primevue/button/sfc';

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');

const {composeUser} = useComposeUser();

const userDataRef = shallowRef(null);
const isLoggedRef = shallowRef(false);

const router = useRouter();
// #endregion

// #region Functions
async function logout() {
  try {
    appState$$.defaultStateApp();
    goToHome();
  } catch (e) {
    useDev.error('[NavigationBar.vue] logout', e);
  }
}

function goToHome() {
  try {
    const dataRoute = {};
    router.push({
      name: `Home`,
      ...dataRoute,
    });
  } catch (e) {
    useDev.error('[NavigationBar.vue] goToHome', e);
  }
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  const isLogged = appState$$.isLogged;
  const token = appState$$.token;

  userDataRef.value = composeUser({
    isLogged,
    token,
  });

  isLoggedRef.value = isLogged;
});

watch(
  () => appState$$.isLogged,
  (value) => {
    isLoggedRef.value = value;
    userDataRef.value = composeUser({
      isLogged: value,
      token: appState$$.token,
    });
  },
);
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.user-menu{
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;

  @include media("<=desktop") {
    display: none !important;
  }

  & span{
    cursor: default;
    margin: 0 5px;
  }

  &__translate, &__search{
    cursor: pointer !important;
  }

  &__search, &__logged{
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: $pv__color--black-alter;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-family: "Open Sans",sans-serif;
    font-size: $pv__fs--medium !important;
    font-weight: 400;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    &__icon{
      cursor: pointer !important;
      margin-left: $brand__boxspace--small;
    }
  }

  &__logged{
    font-weight: 600;
    &__icon{
      background-color: $pv__color--red !important;
      font-weight: 700;
      margin-left: $brand__boxspace--small;
      margin-right: $brand__boxspace--small;
    }
  }
}
</style>
